import { useState } from "react"
import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const AboutPage = () => {
  const [activeTab, setActiveTab] = useState("mission")

  const teamMembers = [
    {
      name: "Rajesh Sharma",
      role: "Founder & Temple Expert",
      image: "/placeholder.svg?height=400&width=400",
      bio: "With over 20 years of experience visiting sacred sites across India, Rajesh founded DivyaTemple to share his knowledge and passion for India's spiritual heritage.",
    },
    {
      name: "Priya Patel",
      role: "Cultural Historian",
      image: "/placeholder.svg?height=400&width=400",
      bio: "Priya holds a PhD in Indian Cultural Studies and has authored several books on temple architecture and religious practices across different regions of India.",
    },
    {
      name: "Amit Verma",
      role: "Travel Specialist",
      image: "/placeholder.svg?height=400&width=400",
      bio: "Amit has organized pilgrimages for thousands of devotees and specializes in creating meaningful spiritual journeys to India's most sacred sites.",
    },
    {
      name: "Sunita Reddy",
      role: "Content Director",
      image: "/placeholder.svg?height=400&width=400",
      bio: "Sunita oversees all content creation, ensuring that the spiritual and historical information on DivyaTemple is accurate, respectful, and accessible to all.",
    },
  ]

  const milestones = [
    {
      year: "2018",
      title: "The Beginning",
      description:
        "DivyaTemple was founded with the mission to document and share information about India's sacred temples.",
    },
    {
      year: "2019",
      title: "100 Temples Documented",
      description:
        "Reached the milestone of documenting 100 temples across 15 states of India with detailed information and high-quality images.",
    },
    {
      year: "2020",
      title: "Virtual Darshan Initiative",
      description:
        "Launched virtual darshan services during the pandemic, allowing devotees to connect with sacred sites from home.",
    },
    {
      year: "2021",
      title: "Mobile App Launch",
      description:
        "Released the DivyaTemple mobile app, making temple information accessible on-the-go for pilgrims and travelers.",
    },
    {
      year: "2022",
      title: "Temple Preservation Fund",
      description:
        "Established a fund dedicated to supporting the preservation and restoration of ancient temples across India.",
    },
    {
      year: "2023",
      title: "1 Million Users",
      description:
        "Celebrated reaching 1 million users, connecting people from over 50 countries to India's spiritual heritage.",
    },
  ]

  const partners = [
    {
      name: "Ministry of Tourism, India",
      logo: "/placeholder.svg?height=100&width=200",
    },
    {
      name: "Archaeological Survey of India",
      logo: "/placeholder.svg?height=100&width=200",
    },
    {
      name: "National Geographic",
      logo: "/placeholder.svg?height=100&width=200",
    },
    {
      name: "Cultural Heritage Foundation",
      logo: "/placeholder.svg?height=100&width=200",
    },
    {
      name: "Indian Railways",
      logo: "/placeholder.svg?height=100&width=200",
    },
  ]

  console.log('I am in about page')

  return (
    <div className="min-h-screen bg-gradient-to-b from-divine-50 via-white to-sacred-50">
      <Navbar />

      {/* Hero Section */}
      <section className="relative py-24 px-4 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{ backgroundImage: "url('/placeholder.svg?height=1000&width=1920')" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-spiritual-900/80 to-spiritual-800/80"></div>
        <div className="container mx-auto relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">About DivyaTemple</h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
            Connecting devotees with India's sacred heritage through knowledge, guidance, and spiritual insights
          </p>
        </div>
      </section>

      {/* Mission & Vision Tabs */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-5xl">
          <div className="flex flex-col sm:flex-row border-b border-gray-200 mb-8">
            <button
              onClick={() => setActiveTab("mission")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "mission"
                  ? "border-b-2 border-spiritual-600 text-spiritual-700"
                  : "text-gray-500 hover:text-spiritual-600"
              }`}
            >
              Our Mission
            </button>
            <button
              onClick={() => setActiveTab("vision")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "vision"
                  ? "border-b-2 border-spiritual-600 text-spiritual-700"
                  : "text-gray-500 hover:text-spiritual-600"
              }`}
            >
              Our Vision
            </button>
            <button
              onClick={() => setActiveTab("values")}
              className={`py-4 px-6 font-medium text-lg ${
                activeTab === "values"
                  ? "border-b-2 border-spiritual-600 text-spiritual-700"
                  : "text-gray-500 hover:text-spiritual-600"
              }`}
            >
              Our Values
            </button>
          </div>

          <div className="bg-divine-50 rounded-xl p-8 shadow-lg">
            {activeTab === "mission" && (
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-spiritual-700 mb-4">Our Mission</h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  DivyaTemple is dedicated to preserving and promoting India's sacred temple heritage by providing
                  accurate, comprehensive information about temples across the country. We aim to make spiritual
                  journeys more accessible and meaningful for devotees, pilgrims, and cultural enthusiasts from around
                  the world.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Through detailed documentation, historical research, and practical travel guidance, we strive to
                  connect people with the divine energy and cultural significance of India's temples, fostering a deeper
                  understanding and appreciation of these sacred spaces.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                  <div className="bg-white rounded-lg p-6 shadow-md">
                    <div className="w-12 h-12 bg-spiritual-100 rounded-full flex items-center justify-center mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-spiritual-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                        />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold text-spiritual-700 mb-2">Document</h3>
                    <p className="text-gray-600">
                      Meticulously document temples with accurate historical, architectural, and spiritual information
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-6 shadow-md">
                    <div className="w-12 h-12 bg-spiritual-100 rounded-full flex items-center justify-center mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-spiritual-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold text-spiritual-700 mb-2">Connect</h3>
                    <p className="text-gray-600">
                      Connect devotees and travelers with sacred sites through practical guidance and spiritual context
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-6 shadow-md">
                    <div className="w-12 h-12 bg-spiritual-100 rounded-full flex items-center justify-center mb-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-spiritual-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold text-spiritual-700 mb-2">Preserve</h3>
                    <p className="text-gray-600">
                      Support preservation efforts to protect India's temple heritage for future generations
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "vision" && (
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-spiritual-700 mb-4">Our Vision</h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  We envision a world where India's sacred temples are recognized and respected as invaluable treasures
                  of human heritage, where their spiritual wisdom and architectural brilliance are accessible to all who
                  seek them.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  DivyaTemple aspires to be the most trusted resource for temple information, creating a digital bridge
                  between ancient wisdom and modern seekers, while fostering a global community united by reverence for
                  sacred spaces.
                </p>
                <div className="bg-gradient-to-r from-spiritual-600 to-spiritual-800 text-white p-8 rounded-lg mt-8">
                  <h3 className="text-2xl font-bold mb-4">Our 2030 Vision</h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <span className="w-6 h-6 bg-white rounded-full text-spiritual-700 flex items-center justify-center mr-3 mt-0.5 font-bold">
                        1
                      </span>
                      <span>
                        Document every significant temple in India with comprehensive information and high-quality
                        visuals
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-6 h-6 bg-white rounded-full text-spiritual-700 flex items-center justify-center mr-3 mt-0.5 font-bold">
                        2
                      </span>
                      <span>Create the world's largest digital archive of temple art, architecture, and rituals</span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-6 h-6 bg-white rounded-full text-spiritual-700 flex items-center justify-center mr-3 mt-0.5 font-bold">
                        3
                      </span>
                      <span>Support restoration projects for at least 100 ancient temples across India</span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-6 h-6 bg-white rounded-full text-spiritual-700 flex items-center justify-center mr-3 mt-0.5 font-bold">
                        4
                      </span>
                      <span>Facilitate meaningful spiritual journeys for 10 million pilgrims annually</span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {activeTab === "values" && (
              <div className="space-y-6">
                <h2 className="text-3xl font-bold text-spiritual-700 mb-4">Our Values</h2>
                <p className="text-lg text-gray-700 leading-relaxed">
                  At DivyaTemple, our work is guided by core values that reflect the spiritual essence of the temples we
                  document. These principles shape every aspect of our organization and our interactions with the
                  community.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                  <div className="bg-white rounded-lg p-6 shadow-md border-l-4 border-sacred-500">
                    <h3 className="text-xl font-bold text-sacred-700 mb-3">Reverence</h3>
                    <p className="text-gray-600">
                      We approach sacred sites with deep respect, honoring their spiritual significance and the devotion
                      they inspire. Our content reflects this reverence, treating all traditions with dignity.
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-6 shadow-md border-l-4 border-royal-500">
                    <h3 className="text-xl font-bold text-royal-700 mb-3">Authenticity</h3>
                    <p className="text-gray-600">
                      We are committed to providing accurate, well-researched information that respects the historical
                      and spiritual authenticity of each temple and tradition.
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-6 shadow-md border-l-4 border-nature-500">
                    <h3 className="text-xl font-bold text-nature-700 mb-3">Inclusivity</h3>
                    <p className="text-gray-600">
                      We celebrate the diversity of India's spiritual traditions, making information accessible to
                      people of all backgrounds, beliefs, and levels of knowledge.
                    </p>
                  </div>
                  <div className="bg-white rounded-lg p-6 shadow-md border-l-4 border-divine-500">
                    <h3 className="text-xl font-bold text-divine-700 mb-3">Service</h3>
                    <p className="text-gray-600">
                      We see our work as seva (selfless service), dedicated to helping pilgrims and seekers connect with
                      divine experiences that enrich their lives.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-sacred-50 to-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-sacred-700 mb-4">Meet Our Team</h2>
            <div className="w-24 h-1 bg-sacred-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Our dedicated team of experts combines spiritual knowledge, historical research, and travel expertise to
              create the most comprehensive temple resource.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={member.image || "/placeholder.svg"}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-sacred-700 mb-1">{member.name}</h3>
                  <p className="text-sacred-600 mb-4">{member.role}</p>
                  <p className="text-gray-600 text-sm">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/contact"
              className="inline-flex items-center bg-sacred-600 hover:bg-sacred-700 text-white px-6 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              Join Our Team
              <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>

      {/* Our Journey Timeline */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-5xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-royal-700 mb-4">Our Journey</h2>
            <div className="w-24 h-1 bg-royal-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              From a passion project to India's leading temple information platform, our journey has been guided by
              devotion and dedication.
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-royal-200"></div>

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div
                  key={index}
                  className={`relative flex items-center ${index % 2 === 0 ? "flex-row" : "flex-row-reverse"}`}
                >
                  <div className="w-1/2"></div>

                  {/* Timeline Dot */}
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-8 h-8 bg-royal-600 rounded-full border-4 border-white z-10 flex items-center justify-center">
                    <span className="text-white font-bold text-xs">{milestone.year.slice(2)}</span>
                  </div>

                  <div className="w-1/2 pl-8 pr-4">
                    <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-royal-500">
                      <div className="text-sm text-royal-600 font-bold mb-1">{milestone.year}</div>
                      <h3 className="text-xl font-bold text-royal-700 mb-2">{milestone.title}</h3>
                      <p className="text-gray-600">{milestone.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-16 px-4 bg-gradient-to-b from-divine-50 to-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-divine-700 mb-4">Our Partners</h2>
            <div className="w-24 h-1 bg-divine-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              We collaborate with leading organizations to preserve and promote India's temple heritage.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="bg-white rounded-lg p-4 shadow-md flex items-center justify-center h-32">
                <img src={partner.logo || "/placeholder.svg"} alt={partner.name} className="max-h-16" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-r from-spiritual-700 to-spiritual-900 text-white">
        <div className="container mx-auto max-w-5xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Join Us in Preserving India's Sacred Heritage</h2>
          <p className="text-xl max-w-3xl mx-auto mb-8">
            Whether you're a devotee, a history enthusiast, or a cultural explorer, there are many ways to be part of
            our mission.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-spiritual-700 hover:bg-divine-100 px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/signup"
              className="bg-transparent hover:bg-white/10 text-white border-2 border-white px-8 py-3 rounded-lg text-lg font-semibold transition-colors"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default AboutPage

